import { render, staticRenderFns } from "./CatalogLine.vue?vue&type=template&id=3aa09161&scoped=true"
import script from "./CatalogLine.vue?vue&type=script&lang=js"
export * from "./CatalogLine.vue?vue&type=script&lang=js"
import style0 from "./CatalogLine.vue?vue&type=style&index=0&id=3aa09161&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa09161",
  null
  
)

export default component.exports